'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RECAPTCHA_ID = exports.TC_ID = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _Button = require('./blocks/Button');

var _Button2 = _interopRequireDefault(_Button);

var _TextBlock = require('./blocks/TextBlock');

var _TextBlock2 = _interopRequireDefault(_TextBlock);

var _TextField = require('./blocks/TextField');

var _TextField2 = _interopRequireDefault(_TextField);

var _CheckField = require('./blocks/CheckField');

var _CheckField2 = _interopRequireDefault(_CheckField);

var _RegionPicker = require('./blocks/RegionPicker');

var _RegionPicker2 = _interopRequireDefault(_RegionPicker);

var _SelectField = require('./blocks/SelectField');

var _SelectField2 = _interopRequireDefault(_SelectField);

var _reactScrollToComponent = require('react-scroll-to-component');

var _reactScrollToComponent2 = _interopRequireDefault(_reactScrollToComponent);

var _RenderHelper = require('./RenderHelper');

var _immutable = require('immutable');

var _shortid = require('shortid');

var _shortid2 = _interopRequireDefault(_shortid);

var _reactCookie = require('react-cookie');

var _RenderWarnings = require('./RenderWarnings');

var _RenderWarnings2 = _interopRequireDefault(_RenderWarnings);

var _libphonenumberJs = require('libphonenumber-js');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var VALIDATION_REGEX = {
  number: /\d+/
};

var TC_ID = exports.TC_ID = 'tc_agree';
var RECAPTCHA_ID = exports.RECAPTCHA_ID = 'recaptcha_id';
var LEAD_ID = 'browser_id';

var emailTester = /^[-!#$%&'*+\/0-9=?A-Z^_a-z{|}~](\.?[-!#$%&'*+\/0-9=?A-Z^_a-z`{|}~])*@[a-zA-Z0-9](-*\.?[a-zA-Z0-9])*\.[a-zA-Z](-?[a-zA-Z])+$/;
var validateEmail = function validateEmail(email) {
  if (!email) return false;

  if (email.length > 254) return false;

  var valid = emailTester.test(email);
  if (!valid) return false;

  var parts = email.split("@");
  if (parts[0].length > 64) return false;

  var domainParts = parts[1].split(".");
  if (domainParts.some(function (part) {
    return part.length > 63;
  })) return false;

  return true;
};

exports.default = (0, _reactCookie.withCookies)((_temp = _class = function (_React$Component) {
  _inherits(RenderForm, _React$Component);

  function RenderForm(props) {
    _classCallCheck(this, RenderForm);

    var _this = _possibleConstructorReturn(this, (RenderForm.__proto__ || Object.getPrototypeOf(RenderForm)).call(this, props));

    _this._initialState = {
      values: new _immutable.Map(),
      errors: new Set(),
      requiredErrors: new Set(),
      phoneErrors: new _immutable.Map(),
      emailErrors: new _immutable.Map()
    };

    _this.scrollToError = function () {
      clearTimeout(_this.scrollTimer);
      _this.scrollTimer = null;

      var firstErrorId = null;
      _this.fields && _this.fields.forEach(function (f) {
        var id = f.get('id');
        if (!firstErrorId && _this.state.errors.has(id)) {
          firstErrorId = id;
          return false;
        }
      });
      (0, _reactScrollToComponent2.default)(_this.fieldComponents.get(firstErrorId));
    };

    _this.handleChange = function (fieldId) {
      return function (data) {
        var values = _this.state.values.set(fieldId, data);
        _this.setState({ values: values }, function () {
          return _this.nextClicked && _this.validate();
        });
      };
    };

    _this.handleNext = function (targetUrl) {
      var _ref = _this.props || {},
          quizId = _ref.quizId;

      _this.nextClicked = true;
      _this.nextTarget = targetUrl;
      _this.validate(function (errorCount) {
        if (errorCount === 0) {
          if (_this.props.isLast) {
            window.quizCapcha[quizId].execute();
          } else {
            _this.reCaptureOk();
          }
        }
      });
    };

    _this.reCaptureOk = function (token) {
      var fieldsInfo = _this.fields.reduce(function (acc, field) {
        var fieldData = field.get('data');
        var fieldName = field.get('text');
        if (!!fieldData && !!fieldData.get('uniquename')) fieldName = fieldData.get('uniquename');
        return acc.set(field.get('id'), new _immutable.Map({
          type: field.get('selected'),
          name: fieldName
        }));
      }, new _immutable.Map());
      var values = _this.state.values;

      if (!!_this.props.data && (_this.props.data.get('isBrowserWrap') || _this.props.data.get('isPrivacyPolicyHidden'))) {
        values = values.set(TC_ID, true);
      }

      values = values.set(LEAD_ID, _this._getLeadId());
      if (token) {
        values = values.set(RECAPTCHA_ID, token);
      }
      if (_this.extraData) {
        Object.keys(_this.extraData).forEach(function (k) {
          values = values.set(k, _this.extraData[k]);
          fieldsInfo = fieldsInfo.set(k, (0, _immutable.Map)({ type: 'additional', name: _this.extraData[k] }));
        });
      }

      if (_this.props.trackEvent) {
        _this.props.trackEvent({ action: 'Submit', label: 'Lead capture form' });
        _this.props.trackEvent({ action: 'Lead submitted' });
      }
      _this.props.onChange && _this.props.onChange(new _immutable.Map({ fieldsInfo: fieldsInfo, values: values }));
      _this.props.handleNext && _this.props.handleNext(_this.nextTarget);
    };

    _this.mountBrowserWrap = function (basicProps) {
      return _react2.default.createElement(
        'div',
        { className: 'wsequiz_checkfield', key: 'browserWrap' },
        _react2.default.createElement(
          'span',
          { className: 'wsequiz_checkfield__label' },
          _react2.default.createElement(
            'label',
            null,
            basicProps.detailed.text
          ),
          _react2.default.createElement('br', null),
          _react2.default.createElement(
            'a',
            { href: basicProps.detailed.url, target: '_blank' },
            basicProps.detailed.link
          )
        )
      );
    };

    _this.mountForm = function () {
      var requiredText = _this.props.settings.getIn(['meta', 'required']) || 'Required';
      var phoneErrorText = _this.props.settings.getIn(['meta', 'phone_error']) || 'Invalid Phone Number';
      var emailErrorText = _this.props.settings.getIn(['meta', 'email_error']) || 'Invalid Email';
      var optionalText = _this.props.settings.getIn(['meta', 'optional']) || 'optional';
      var regionList = _this.props.settings.get('regions') ? _this.props.settings.get('regions').toJS() : false;
      var regionLabel = _this.props.settings.getIn(['meta', 'select_region']) || 'Select Region';
      var centerLabel = _this.props.settings.getIn(['meta', 'select_center']) || 'Select Center';

      var currentScreenClass = 'wsequiz_form wsequiz_renderForm__form';
      if (!!_this.props.data && _this.props.data.get('isRTL')) {
        currentScreenClass += ' wsequiz_rtl';
      }

      return _react2.default.createElement(
        'div',
        { className: currentScreenClass },
        _this.fields.map(function (field) {
          var id = field.get('id');
          var compulsory = field.get('compulsory');
          var selected = field.get('selected');
          var error = _this.state.requiredErrors.has(id);
          var phoneError = _this.state.phoneErrors.has(id);
          var emailError = _this.state.emailErrors.has(id);

          var basicProps = {
            key: id,
            ref: function ref(_ref2) {
              return _this.fieldComponents[id] = _ref2;
            },
            onChange: _this.handleChange(field.get('id')),
            selected: selected,
            error: error,
            phoneError: phoneError,
            emailError: emailError,
            hintText: field.get('hintText'),
            text: field.get('text'),
            detailed: field.get('detailed'),
            subtext: compulsory ? '' : ' (' + optionalText + ')',
            data: field.get('data'),
            compulsory: compulsory
          };

          if (selected === 'telephone' && !field.get('hintText')) {
            basicProps.hintText = _this.props.settings.getIn(['meta', 'dialing']) || '';
          }

          var argMatch = _this.formArgs.find(function (fa) {
            return fa.field.toLowerCase() === field.get('selected').toLowerCase();
          });
          if (!!argMatch) {
            basicProps.defaultValue = argMatch.value;
          }

          switch (selected) {
            case 'centre':
              return _react2.default.createElement(_RegionPicker2.default, _extends({}, basicProps, {
                regions: regionList,
                regionLabel: regionLabel,
                centerLabel: centerLabel
              }));
            case 'checkbox':
              return _react2.default.createElement(_CheckField2.default, basicProps);
            case 'checkboxLink':
              return _react2.default.createElement(_CheckField2.default, basicProps);
            case 'customSelect':
              return _react2.default.createElement(_SelectField2.default, basicProps);
            case 'browserWrap':
              return _this.mountBrowserWrap(basicProps);
            default:
              return _react2.default.createElement(_TextField2.default, basicProps);
          }
        }),
        _this.state.requiredErrors.size > 0 && _react2.default.createElement(
          'label',
          { className: 'wsequiz_error_text' },
          '* ',
          requiredText
        ),
        _react2.default.createElement('br', null),
        _this.state.phoneErrors.size > 0 && _react2.default.createElement(
          'label',
          { className: 'wsequiz_error_text' },
          '** ',
          phoneErrorText
        ),
        _react2.default.createElement('br', null),
        _this.state.emailErrors.size > 0 && _react2.default.createElement(
          'label',
          { className: 'wsequiz_error_text' },
          '** ',
          emailErrorText
        )
      );
    };

    _this.mountActions = function () {
      var _this$props = _this.props,
          data = _this$props.data,
          previewQuizScreen = _this$props.previewQuizScreen,
          preview = _this$props.preview,
          trackEvent = _this$props.trackEvent;


      return _react2.default.createElement(
        'div',
        { className: 'wsequiz_renderForm__actions' },
        _this.fields && _this.mountForm(),
        data.get('primaryButton') && _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(_Button2.default, {
            data: data.get('primaryButton'),
            handleNext: _this.handleNext,
            primary: true,
            previewQuizScreen: previewQuizScreen,
            trackEvent: trackEvent
          })
        )
      );
    };

    _this._reset();
    _this.state = Object.assign(_this._initialState);
    _this.scrollTimer = null;
    return _this;
  }

  _createClass(RenderForm, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (!(0, _immutable.is)(nextProps.data.get('fields'), this.props.data.get('fields') || [])) {
        this._reset();
        this.setState(Object.assign(this._initialState));
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this.scrollTimer);
    }
  }, {
    key: 'mapArgFields',
    value: function mapArgFields() {
      var _this2 = this;

      this.extraData = {};
      this.formArgs = Object.assign({}, this.props.formArgs);
      if (!this.formArgs.name && !!this.formArgs.firstname) {
        this.formArgs.name = this.formArgs.firstname;
        delete this.formArgs.firstname;
      }
      if (!this.formArgs.surname && !!this.formArgs.lastname) {
        this.formArgs.surname = this.formArgs.lastname;
        delete this.formArgs.lastname;
      }

      this.formArgs = Object.keys(this.formArgs).map(function (fa) {
        var matchingField = _this2.fields.find(function (f) {
          return f.get('selected').toLowerCase() === fa.toLowerCase();
        });
        if (matchingField) {
          return {
            field: matchingField.get('selected'),
            key: fa,
            value: _this2.formArgs[fa]
          };
        } else {
          _this2.extraData[fa] = _this2.formArgs[fa];
          return null;
        }
      }).filter(function (f) {
        return !!f;
      });
    }
  }, {
    key: '_reset',
    value: function _reset() {
      this.nextClicked = false;
      this.nextTarget = null;
      clearTimeout(this.scrollTimer);
      this.scrollTimer = null;
      this.fieldComponents = new _immutable.Map();
      this.fields = this.props.data.get('fields') || [];
      this.mapArgFields();
      var metaData = this.props.settings.get('meta') ? this.props.settings.get('meta').toJSON() : false;
      var tcWrap = false;
      var hidePP = false;

      if (!!this.props.data && this.props.data.get('isBrowserWrap')) {
        tcWrap = true;
      }
      if (!!this.props.data && this.props.data.get('isPrivacyPolicyHidden')) {
        tcWrap = true;
        hidePP = true;
      }
      if (this.props.isLast) {
        window.reCaptureOk = this.reCaptureOk;
        var tcInfo = {
          link: "Privacy Policy",
          text: "I have read and I accept the Privacy Policy",
          url: "https://www.wallstreetenglish.com/user-privacy-policy-activity-builder/"
        };
        if (metaData && metaData.terms) {
          tcInfo.link = !!metaData.terms.link ? metaData.terms.link : tcInfo.link;
          tcInfo.text = !!metaData.terms.text ? metaData.terms.text : tcInfo.text;
          tcInfo.url = !!metaData.terms.url ? metaData.terms.url : tcInfo.url;
        }
        if (tcWrap && !!metaData.terms.bwtext) {
          tcInfo.text = !!metaData.terms.bwtext ? metaData.terms.bwtext : tcInfo.text;
        }
        if (hidePP) {
          tcInfo = {
            link: '',
            text: '',
            url: ''
          };
        }
        this.fields = this.fields.push(new _immutable.Map({
          id: TC_ID,
          compulsory: true,
          selected: tcWrap ? 'browserWrap' : 'checkbox',
          detailed: tcInfo
        }));
      }
    }
  }, {
    key: '_getLeadId',
    value: function _getLeadId() {
      var leadId = this.props.cookies.get('wse-quiz-lead-id');
      if (!leadId) {
        leadId = _shortid2.default.generate();
        var expDate = new Date();
        expDate.setFullYear(expDate.getFullYear() + 1);
        this.props.cookies.set('wse-quiz-lead-id', leadId, { path: '/', expires: expDate });
      }
      return leadId;
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.scrollTimer && clearTimeout(this.scrollTimer);
      this.scrollTimer = setTimeout(this.scrollToError, 200);
    }
  }, {
    key: 'splitRegionValueIntoArray',
    value: function splitRegionValueIntoArray(value) {
      if (!value) return [];
      var matcher = value.match(/([^:]+)/g);
      return matcher ? matcher.map(function (match) {
        return match.trim();
      }) : [];
    }
  }, {
    key: 'getSelectedRegionOptions',
    value: function getSelectedRegionOptions(values) {
      var _values = _slicedToArray(values, 3),
          regionName = _values[0],
          centerName = _values[1],
          optionName = _values[2];

      var region = this.props.regions.find(function (region) {
        return region.get('name').trim() === regionName;
      });
      var hasCenters = region && region.get('centers').size > 0;
      var centers = centerName && region.get('centers') && region.get('centers').filter(function (center) {
        return center.get('name').startsWith(centerName);
      });
      var hasSubcenters = centers && centers.filter(function (option) {
        return option.get('name').includes('||');
      }).size > 0;

      return {
        hasCenters: hasCenters,
        hasSubcenters: hasSubcenters
      };
    }
  }, {
    key: 'validate',
    value: function validate(callback) {
      var _this3 = this;

      var errors = new Set();
      var requiredErrors = new Set();
      var phoneErrors = new Set();
      var emailErrors = new Set();
      this.fields && this.fields.forEach(function (f) {
        var id = f.get('id');
        var value = _this3.state.values.get(id);
        var err = false;
        var phoneErr = false;
        var emailErr = false;
        err = err || f.get('compulsory') && !value;
        var validationRegexes = Object.assign({}, VALIDATION_REGEX);

        var regex = validationRegexes[f.get('selected')];
        if (regex) {
          err = err || value && !value.trim().match(regex);
        }

        if (f.get('selected') === 'centre' && f.get('compulsory')) {
          var regionValues = _this3.splitRegionValueIntoArray(value);
          if (regionValues) {
            var _getSelectedRegionOpt = _this3.getSelectedRegionOptions(regionValues),
                hasCenters = _getSelectedRegionOpt.hasCenters,
                hasSubcenters = _getSelectedRegionOpt.hasSubcenters;

            var isRequiredSubcenter = hasSubcenters && !regionValues[2];
            var isRequiredCenter = hasCenters && !regionValues[1];
            var isRequiredRegion = !regionValues[0];

            var hasRequiredFields = isRequiredSubcenter || isRequiredCenter || isRequiredRegion;
            err = hasRequiredFields;
          }
        }

        if (f.get('selected') === 'email') {
          if (!value || value && !validateEmail(value)) {
            emailErr = true;
          }
        }

        if (f.get('selected') === 'telephone') {
          var phoneNumber = (0, _libphonenumberJs.parsePhoneNumberFromString)(value || '');
          if (value && (!phoneNumber || !phoneNumber.isValid())) {
            phoneErr = true;
          }
        }

        var isBrowserWrapTC = id === TC_ID && !!_this3.props.data && _this3.props.data.get('isBrowserWrap');
        var isPrivacyPolicyHidden = id === TC_ID && !!_this3.props.data && _this3.props.data.get('isPrivacyPolicyHidden');
        if (err && !isBrowserWrapTC && !isPrivacyPolicyHidden) {
          errors = errors.add(id);
          requiredErrors = requiredErrors.add(id);
        }
        if (phoneErr) {
          errors = errors.add(id);
          phoneErrors = phoneErrors.add(id);
        }
        if (emailErr) {
          errors = errors.add(id);
          emailErrors = emailErrors.add(id);
        }
      });
      this.setState({ errors: errors, requiredErrors: requiredErrors, phoneErrors: phoneErrors, emailErrors: emailErrors }, function () {
        return callback && callback(errors.size);
      });
    }
  }, {
    key: 'mountContent',
    value: function mountContent() {
      var _props = this.props,
          data = _props.data,
          handleNext = _props.handleNext,
          previewQuizScreen = _props.previewQuizScreen,
          preview = _props.preview,
          trackEvent = _props.trackEvent;

      var texts = data.get('texts');
      var buttons = data.get('buttons');
      var btnProps = { handleNext: handleNext, previewQuizScreen: previewQuizScreen, trackEvent: trackEvent };

      return _react2.default.createElement(
        'div',
        { className: 'wsequiz_renderForm__content' + (preview ? ' preview' : '') },
        texts && texts.map(function (text) {
          return _react2.default.createElement(_TextBlock2.default, { key: text.get('id'), data: text });
        }),
        buttons && buttons.map(function (button) {
          return _react2.default.createElement(_Button2.default, _extends({ key: button.get('id'), data: button }, btnProps));
        })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { ref: this.props.measureRef, className: this.props.className + ' wsequiz_renderForm' },
        _react2.default.createElement(_RenderWarnings2.default, this.props),
        _react2.default.createElement(
          'div',
          { className: 'wsequiz_renderForm__inner' },
          this.mountContent(),
          this.mountActions()
        )
      );
    }
  }]);

  return RenderForm;
}(_react2.default.Component), _class.propTypes = {
  trackEvent: _propTypes.PropTypes.func
}, _temp));


//////////////////
// WEBPACK FOOTER
// ./node_modules/wse-quiz-component/lib/RenderForm.js
// module id = 370
// module chunks = 0